import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TrustedBrands from "./sections/TrustedBrands";
import OurServicesPreview from "./sections/OurServicesPreview";
import FeaturedWork from "./sections/FeaturedWork";
import OurProcess from "./sections/OurProcess";
import ClientTestimonials from "./sections/ClientTestimonials";
import FinalCallToAction from "./sections/FinalCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <TrustedBrands />
      <OurServicesPreview />
      <FeaturedWork />
      <OurProcess />
      <ClientTestimonials />
      <FinalCallToAction />
      <Footer />
    </div>;
}